import { LOCATION_CHANGE } from 'connected-react-router';
import {
  GET_SCRIBE_FOR_PLAYBACK_SUCCESS,
  GET_SCRIBE_FOR_PLAYBACK_ERROR,
  SET_MUTED,
  PLAY_FROM_EDITOR,
  PLAYBACK_IS_READY,
  START_PLAYBACK,
  STOP_PLAYBACK
} from 'JS/actionCreators/playbackActions';
import { UNLOAD_PLAYBACK } from 'JS/actionCreators/uiActions';

const initialState = {
  playbackScribe: null,
  error: null,
  audioMuted: undefined,
  showPlaybackView: false,
  startingElementId: null,
  autoPlay: true,
  isRecordingAudio: false,
  playAudio: true,
  playbackIsReady: false,
  startPlayback: false
};

export default function playbackReducer(state = initialState, action) {
  switch (action.type) {
    case PLAY_FROM_EDITOR: {
      return {
        ...state,
        audioMuted: typeof state.audioMuted === 'undefined' ? false : state.audioMuted,
        showPlaybackView: true,
        startingElementId: action.startingElementId,
        autoPlay: action.autoPlay,
        isRecordingAudio: action.isRecordingAudio,
        playAudio: action.playAudio,
        playbackIsReady: false,
        startPlayback: action.autoPlay ? true : false
      };
    }

    case STOP_PLAYBACK:
    case UNLOAD_PLAYBACK:
    case LOCATION_CHANGE: {
      return {
        ...state,
        ...initialState,
        showPlaybackView: false,
        audioMuted: state.audioMuted
      };
    }

    case PLAYBACK_IS_READY: {
      return {
        ...state,
        playbackIsReady: true
      };
    }

    case START_PLAYBACK: {
      return {
        ...state,
        startPlayback: true
      };
    }

    case GET_SCRIBE_FOR_PLAYBACK_SUCCESS: {
      return {
        ...state,
        playbackScribe: action.scribeData,
        error: null
      };
    }

    case GET_SCRIBE_FOR_PLAYBACK_ERROR: {
      return {
        ...state,
        playbackScribe: null,
        error: action.error
      };
    }

    case SET_MUTED: {
      return {
        ...state,
        audioMuted: action.muted
      };
    }

    default:
      return state;
  }
}
